var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Border } from '@atomic/obj.constants';
export var Divider = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  width: 100%;\n  background-color: ", ";\n"], ["\n  height: ", ";\n  width: 100%;\n  background-color: ", ";\n"])), Border.Width, Border.Color);
var templateObject_1;
